export default "<a [href]=\"linkUrl\">\r\n  {{linkTitle}}\r\n</a>\r\n";